module.exports = __webpack_public_path__ + "static/media/pic6@3x.f34e24f7.png";